import React from 'react';
import { CustomReportsTool } from './custom-report-tool';

export const CustomReportBuilder = props => {
  return <CustomReportsTool isBuilder={true} {...props} />;
};
